import Player from '@vimeo/player';

const playVideo = (event, el, player, type) => {
    event.preventDefault();
    el.classList.add('playing');
    // document.body.classList.add('stop-scrolling');

    // Delay for animation
    setTimeout(() => {
        if (type === 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }
    }, 300);
};

const initVideoEmbeds = (elements) => {
    const youTubeVids = [];
    const vimeoVids = [];

    elements.forEach((el) => {
        const embedType = el.dataset.videoEmbed;

        if (embedType === 'youtube') {
            youTubeVids.push(el);
        } else {
            vimeoVids.push(el);
        }
    });

    if (youTubeVids.length) {
        const ytScript = document.getElementById('youtubeAPI');

        if (!ytScript) {
            const scriptEl = document.createElement('script');
            scriptEl.src = 'https://www.youtube.com/player_api';
            scriptEl.id = 'youtubeAPI';

            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(scriptEl, firstScriptTag);
        }

        let YT;

        window.onYouTubePlayerAPIReady = () => {
            YT = window.YT;

            youTubeVids.forEach((el) => {
                const video = el.querySelector('.js-video-iframe');
                const player = new YT.Player(video);
                const openBtns = el.querySelectorAll('.js-play-video');

                openBtns.forEach((btn) => {
                    btn.addEventListener('click', () => {
                        playVideo(event, el, player, 'youtube');
                    });
                });
            });
        };
    }

    if (vimeoVids.length) {
        vimeoVids.forEach((el) => {
            const video = el.querySelector('.js-video-iframe');
            const player = new Player(video);
            const openBtns = el.querySelectorAll('.js-play-video');

            openBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    playVideo(event, el, player, 'vimeo');
                });
            });
        });
    }
};

export default initVideoEmbeds;